import type { TickerConfig } from "@/types/ticker";
import { request } from "./transport";

export interface TickerRow extends TickerConfig {
  readonly auto_added: boolean;
  readonly poll_tier: "hot" | "warm" | "cold";
  readonly search_score: number;
  readonly last_searched_at: string | null;
}

export type DiscoverStatus = "ready" | "discovered" | "unsupported" | "invalid";

export interface DiscoverResponse {
  readonly status: DiscoverStatus;
  readonly ticker?: TickerRow;
  readonly reason?: string;
}

export type SessionState = "rth" | "post_close" | "pre_market" | "closed";

export interface TickerSessionSummary {
  readonly ticker: string;
  readonly price: number | null;
  readonly previous_close: number | null;
  readonly change_abs: number | null;
  readonly change_pct: number | null;
  readonly session_state: SessionState;
  readonly as_of: string | null;
}

export const tickers = {
  listTickers: () =>
    request<{ tickers: TickerRow[] }>(`/tickers`).then((r) => r.tickers),

  discoverTicker: (symbol: string) =>
    request<DiscoverResponse>(`/tickers/discover`, {
      method: "POST",
      body: JSON.stringify({ symbol }),
    }),

  getTickerSessionSummary: (symbol: string) =>
    request<TickerSessionSummary>(
      `/tickers/${encodeURIComponent(symbol)}/session_summary`,
    ),
};
